import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X, Hexagon } from "lucide-react";
import { LuxuryButton } from "@/components/lux";

const NAV = [
  { label: "Home", to: "/#home" },
  { label: "About", to: "/#about" },
  { label: "How It Works", to: "/#how" },
  { label: "Trading", to: "/#trading" },
  { label: "Security", to: "/#security" },
  { label: "Contact", to: "/#contact" },
];

export default function PublicNav() {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  return (
    <header className="fixed inset-x-0 top-0 z-50">
      <div className="mx-auto mt-4 flex max-w-7xl items-center justify-between gap-4 rounded-2xl glass px-5 py-3 theme-light">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-logo">
          <img src="/logo.png" alt="Alexa Fintech" className="h-11 w-auto object-contain" />
        </Link>
        <nav className="hidden items-center gap-1 lg:flex">
          {NAV.map((n) => (
            <a key={n.label} href={n.to} className="rounded-lg px-3 py-2 text-sm font-medium text-[var(--text-dim)] transition hover:text-[var(--royal)]">
              {n.label}
            </a>
          ))}
        </nav>
        <div className="hidden items-center gap-3 md:flex">
          <LuxuryButton variant="dark" size="sm" onClick={() => nav("/login")} data-testid="nav-login-btn">Login</LuxuryButton>
          <LuxuryButton size="sm" onClick={() => nav("/register")} data-testid="nav-register-btn">Join Now</LuxuryButton>
        </div>
        <button className="md:hidden text-white" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="mx-auto mt-2 max-w-7xl rounded-2xl glass p-4 theme-light md:hidden">
          <div className="flex flex-col gap-1">
            {NAV.map((n) => (
              <a key={n.label} href={n.to} onClick={() => setOpen(false)} className="rounded-lg px-3 py-2 text-sm font-medium text-[var(--text-dim)] hover:text-[var(--royal)]">{n.label}</a>
            ))}
            <div className="mt-2 flex gap-2">
              <LuxuryButton variant="dark" size="sm" className="flex-1" onClick={() => nav("/login")}>Login</LuxuryButton>
              <LuxuryButton size="sm" className="flex-1" onClick={() => nav("/register")}>Join Now</LuxuryButton>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
